import { skipToken } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { RecordDraft, RecordFinal } from '../../types/sharedTypeImpl.ts';
import { recordToDraft } from '../../utils/conversion.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


export function useInitRecord(
    initialRecordId: string | null,
    record: RecordDraft | null,
    setRecord: (record: RecordDraft) => void,
    isEditMode: boolean,
) {
    const [isFinishedRecord, setisFinishedRecord] = useState(false);// Has record been finalized and then reopened

    const recordFetch = trpc.records.getById.useQuery(
        initialRecordId ?? skipToken,
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
        }
    );

    useEffect(() => {
        if (recordFetch.data && record?._id !== recordFetch.data._id) {
            if (recordFetch.data.isDraft) {
                setRecord(recordFetch.data as RecordDraft);
                setisFinishedRecord(false);
            } else {
                const newRecord = recordToDraft(recordFetch.data as RecordFinal);
                if (isEditMode) {
                    newRecord.edits = [
                        ...(newRecord.edits ?? []),
                        { editedBy: '' },
                    ];
                }
                setRecord(newRecord);
                setisFinishedRecord(true);
            }
        }
    }, [recordFetch.data, record, isEditMode, setisFinishedRecord, setRecord]);

    return {
        recordFetch,
        isFinishedRecord,
    };
}
